import { Suspense, useCallback, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box, Loader } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import useNavigation from '@/hooks/useNavigation';
import routes from '@/pages/corporate/routes';

import useFile from '../../../hooks/useFile';
import useFileActions from '../../../hooks/useFileActions';
import { DialogProps } from '../types';
import SectionEditorContainer from './SectionEditorContainer';

function SectionEditor({ onClose, folderId }: DialogProps) {
  const { t } = useTranslation('Task');
  const navigation = useNavigation();

  const [formikSubmit, setFormikSubmit] = useState<any>();
  const { state, methods } = useFileActions({ onSuccess: onClose });
  const { isFetching } = state;
  const { createSectionWithEmptyList, updateSection } = methods;
  const { fetching: fetchingFile, file, error } = useFile({ fileId: folderId });

  const onSubmit = useCallback(
    async (val: any) => {
      if (folderId) {
        updateSection(folderId, val);
        return;
      }

      const response = await createSectionWithEmptyList(val);

      if (response?.listId) {
        navigation.push(routes.TasksList(response.listId));
        return;
      }
    },
    [folderId, createSectionWithEmptyList, updateSection, navigation],
  );

  return (
    <Modal
      action={{
        disabled: isFetching || fetchingFile,
        isSubmitting: isFetching,
        text: file ? t('Common:Actions.Save') : t('Common:Actions.Create'),
        onSubmit: formikSubmit,
      }}
      header={{
        title: file ? t('Task:Section.EditSection') : t('Task:Section.NewSection'),
        description: file
          ? t('Task:Section.EditSectionDescription')
          : t('Task:Section.NewSectionDescription'),
      }}
      onClose={onClose}>
      <Box className="px-24 pt-8 pb-24">
        <Suspense fallback={<Loader className="mx-auto my-auto" />}>
          <SectionEditorContainer
            error={error}
            fetching={fetchingFile}
            file={file}
            setFormikSubmit={setFormikSubmit}
            onSubmit={onSubmit}
          />
        </Suspense>
      </Box>
    </Modal>
  );
}

export default SectionEditor;
